const SENSITIVE_HINT = /cpf|cnpj|senha|password/;

export function clarityProjectId(env) {
  const raw = env && env.VUE_APP_CLARITY_PROJECT_ID;
  if (typeof raw !== "string") {
    return "";
  }
  return raw.trim();
}

export function shouldStartClarity(env) {
  return clarityProjectId(env) !== "";
}

export function startClarity(clarityClient, env, onPasswordRecovery = false) {
  const projectId = clarityProjectId(env);
  if (
    onPasswordRecovery
    || !projectId
    || !clarityClient
    || typeof clarityClient.init !== "function"
  ) {
    return false;
  }
  try {
    clarityClient.init(projectId);
  } catch (_error) {
    return false;
  }
  return true;
}

export const CLARITY_SCREEN_TAG = "tela";

// Mesma lista de forceSessionExpired.js. Não mandar essas telas ao Clarity.
const PASSWORD_RECOVERY_SCREENS = [
  "/usuario/senha/esqueceu",
  "/usuario/senha/reset",
];

export function clarityScreenName(route) {
  const matched = route && route.matched;
  if (!Array.isArray(matched) || matched.length === 0) {
    return "";
  }
  const record = matched[matched.length - 1];
  if (!record || typeof record.path !== "string") {
    return "";
  }
  let screen = record.path.trim();
  if (!screen || screen === "*") {
    return "";
  }
  if (screen.length > 1) {
    screen = screen.replace(/\/+$/, "");
  }
  if (PASSWORD_RECOVERY_SCREENS.indexOf(screen) !== -1) {
    return "";
  }
  return screen;
}

export function trackClarityScreen(clarityClient, route) {
  if (!clarityClient || typeof clarityClient.setTag !== "function") {
    return false;
  }
  const screen = clarityScreenName(route);
  if (!screen) {
    return false;
  }
  try {
    clarityClient.setTag(CLARITY_SCREEN_TAG, screen);
  } catch (_error) {
    return false;
  }
  return true;
}

export function isSensitiveField(element) {
  if (!element || typeof element.getAttribute !== "function") {
    return false;
  }
  const type = String(element.getAttribute("type") || "").toLowerCase();
  if (type === "password") {
    return true;
  }
  const hint = ["name", "id", "placeholder", "aria-label"]
    .map((attribute) => element.getAttribute(attribute) || "")
    .join(" ")
    .toLowerCase();
  return SENSITIVE_HINT.test(hint);
}

export function maskSensitiveFields(doc) {
  if (!doc || typeof doc.querySelectorAll !== "function") {
    return;
  }
  const fields = doc.querySelectorAll("input, textarea");
  for (let index = 0; index < fields.length; index += 1) {
    const field = fields[index];
    if (isSensitiveField(field) && typeof field.setAttribute === "function") {
      field.setAttribute("data-clarity-mask", "true");
    }
  }
}

let maskObserverInstalled = false;

export function installSensitiveFieldMask(doc) {
  maskSensitiveFields(doc);
  if (
    maskObserverInstalled
    || !doc
    || !doc.body
    || typeof MutationObserver === "undefined"
  ) {
    return;
  }
  maskObserverInstalled = true;
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) {
      return;
    }
    scheduled = true;
    const run = () => {
      scheduled = false;
      maskSensitiveFields(doc);
    };
    if (typeof requestAnimationFrame === "function") {
      requestAnimationFrame(run);
    } else {
      setTimeout(run, 16);
    }
  });
  observer.observe(doc.body, { childList: true, subtree: true });
}
